import React from 'react';
import { Target, Zap, TrendingUp, Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const principleIcons = [Zap, Target, TrendingUp, Globe];

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen pt-32 pb-20 px-6 bg-black">
      <div className="container mx-auto max-w-5xl">
        {/* Header */}
        <div className="text-center mb-20">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            {t.about.title.includes('13Labs') ? (
              <>
                {t.about.title.split('13Labs')[0]}
                <span className="text-[#D6CE15] neon-text">13Labs</span>
                {t.about.title.split('13Labs')[1]}
              </>
            ) : (
              t.about.title
            )}
          </h1>
        </div>

        {/* Mission */}
        <div className="mb-20">
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-[#D6CE15]/20 rounded-2xl p-10 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#D6CE15]/10 rounded-full blur-3xl" />
            <div className="relative z-10">
              <h2 className="text-3xl font-bold text-white mb-6">
                {t.about.mission.title}
              </h2>
              <p className="text-lg text-gray-300 leading-relaxed">
                {t.about.mission.content}
              </p>
            </div>
          </div>
        </div>

        {/* Principles */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-white mb-10 text-center">
            {t.about.principles.title}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {t.about.principles.items.map((principle, index) => {
              const Icon = principleIcons[index];
              return (
                <div
                  key={index}
                  className="bg-[#0a0a0a] border border-[#D6CE15]/20 rounded-xl p-8 hover:border-[#D6CE15] transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="w-12 h-12 bg-[#D6CE15]/10 rounded-lg flex items-center justify-center mb-4 border border-[#D6CE15]/30">
                    <Icon className="text-[#D6CE15]" size={24} />
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-3">
                    {principle.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed">
                    {principle.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Location */}
        <div>
          <div className="bg-[#0a0a0a] border border-[#D6CE15]/20 rounded-2xl p-10">
            <div className="flex items-start space-x-4 mb-6">
              <div className="w-12 h-12 bg-[#D6CE15]/10 rounded-lg flex items-center justify-center flex-shrink-0 border border-[#D6CE15]/30">
                <Globe className="text-[#D6CE15]" size={24} />
              </div>
              <h2 className="text-3xl font-bold text-white">
                {t.about.location.title}
              </h2>
            </div>
            <p className="text-lg text-gray-400 leading-relaxed">
              {t.about.location.content}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;